import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/form-categories';

const getAll = async (params?: {
	page?: number;
	limit?: number;
}): Promise<Forms.PaginatedFormCategories> => {
	const queryParams = createQueryParams(params ?? {});
	const queryString = queryParams.toString();
	const url = queryString ? `${DOMAIN}?${queryString}` : DOMAIN;
	const { data } = await api.get(url);
	return data;
};

const getById = async (id: string): Promise<Forms.FormCategoryCatalog> => {
	const { data } = await api.get(`${DOMAIN}/${id}`);
	return data;
};

const create = async (
	body: Forms.CreateFormCategory,
): Promise<Forms.FormCategoryCatalog> => {
	const { data } = await api.post(DOMAIN, body);
	return data;
};

const patch = async (
	id: string,
	body: Forms.UpdateFormCategory,
): Promise<Forms.FormCategoryCatalog> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const remove = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${id}`);
};

const addSubcategory = async (
	categoryId: string,
	body: Forms.CreateFormSubcategory,
): Promise<Forms.FormSubcategoryCatalog> => {
	const { data } = await api.post(
		`${DOMAIN}/${categoryId}/subcategories`,
		body,
	);
	return data;
};

const patchSubcategory = async (
	categoryId: string,
	subcategoryId: string,
	body: Forms.UpdateFormSubcategory,
): Promise<Forms.FormSubcategoryCatalog> => {
	const { data } = await api.patch(
		`${DOMAIN}/${categoryId}/subcategories/${subcategoryId}`,
		body,
	);
	return data;
};

const removeSubcategory = async (
	categoryId: string,
	subcategoryId: string,
): Promise<void> => {
	await api.delete(`${DOMAIN}/${categoryId}/subcategories/${subcategoryId}`);
};

const FormCategoryService = {
	getAll,
	getById,
	create,
	patch,
	remove,
	addSubcategory,
	patchSubcategory,
	removeSubcategory,
};

export { FormCategoryService };
